export const PREFERENCE_STORE_REQ = 'PREFERENCE_STORE_REQ'



// WEBPACK FOOTER //
// ./src/store/modules/column-preference/column-preference.type.js